/* KINOVA — Bosqich 5: qidiruv sahifasi.

   Bu sahifa TO'LIQ server tomonda (Blade) render qilinadi — oddiy
   <form method="GET">/<a href> navigatsiya, JS-ga bog'liq holat yo'q
   (tab almashtirish, modal va h.k. kabi emas). Global app.js zanjiri
   (main.js: injectChrome/paintIconSlots/wireHeaderScroll/wireMobileDrawer)
   headerni, ikonalarni va mobil menyuni allaqachon avtomatik ishga
   tushiradi — bu yerda QAYTA yozilmaydi.

   14-bosqich (Talab #1): qidiruv maydoni yangi "pill" ko'rinishga o'tdi
   (.search-hero) va ichida TOZALASH tugmasi bor — quyidagi kod faqat
   shu tugmani boshqaradi. Progressive enhancement: JS o'chirilgan
   bo'lsa tugma ko'rinmaydi (Blade `hidden` bilan boshlaydi va faqat
   matn bo'lsa ko'rsatiladi), forma esa baribir to'liq ishlaydi. */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var input = document.getElementById('searchPageInput');
    var clear = document.getElementById('searchPageClear');
    if (!input || !clear) return;

    function sync() { clear.hidden = input.value.trim() === ''; }

    input.addEventListener('input', sync);
    clear.addEventListener('click', function () {
      input.value = '';
      sync();
      input.focus();
    });

    sync();
  });
})();
